'use client'

import React, { useContext } from 'react'
import {
  CKrNewsletterModal,
  CLocaleSwitcher,
  CReferencesModal,
  CTheFooter,
  CTheHeader,
  CEntryModal,
  CExitIntentModal,
} from 'ui'
import dynamic from 'next/dynamic'
import { CraftGlobals } from 'tsconfig/craft-types'
import { HeaderContext } from 'ui/context/header'
import { MastheadContext } from 'ui/context/masthead'
import { useSiteInfo } from 'shared'
import { proximaFont } from '../fonts'

type Props = {
  children: React.ReactNode
  global: CraftGlobals
}

const DynamicPreviewToast = dynamic(() =>
  import(/* webpackChunkName: "DynamicPreviewToast" */ 'ui').then(
    (x) => x.CPreviewToast
  )
)

const DefaultLayout = ({ children, global }: Props) => {
  const siteInfo = useSiteInfo()
  const headerContext = useContext(HeaderContext)
  const mastheadContext = useContext(MastheadContext)
  const isPreviewToastEnabled = Boolean(
    process.env.NEXT_PUBLIC_PREVIEW_MESSAGE_ENABLED
  )

  const hideDoctorButton = global?.headerFindADoctorButton?.[0]?.hideCta

  return (
    <main
      className={`${proximaFont.variable} ${
        siteInfo.isKR && 's-word-break-keep-all'
      }`}
      dir={siteInfo.dir}
    >
      <CTheHeader
        isVisible={headerContext?.isVisible}
        position={'sticky'}
        theme={'light'}
        isClear={false}
        isClearDark={headerContext?.isClearDark}
        hasProgressBar={headerContext?.hasProgressBar}
        countryCode={siteInfo.iso}
        backendUrl={process.env.NEXT_PUBLIC_DISCOVERICL_BACKEND_URL}
        brand={siteInfo.branded}
        doctorsUrl={!hideDoctorButton ? siteInfo.doctorUrl : undefined}
        quizUrl={siteInfo.quizUrl}
        baseDomain={process.env.NEXT_PUBLIC_DISCOVERICL_BASE_DOMAIN}
        discoveryUrl={siteInfo.discoverUrl}
        fullDomain={'/'}
        topFooterLinks={global.topFooterLinks || []}
        bottomFooterLinks={global.bottomFooterLinks || []}
        headerTopNavMenu={global.headerTopNavMenu}
        headerTopBar={global.headerTopBar}
        logo={global?.logo}
        notificationBar={global?.notificationBar}
      />
      {children}
      <CLocaleSwitcher
        open={headerContext?.showLocaleSwitcher ?? false}
        onClose={() => headerContext?.setShowLocaleSwitcher(false)}
        domain={process.env.NEXT_PUBLIC_DISCOVERICL_BASE_DOMAIN ?? ''}
        entry={global?.localeSwitcher}
      />
      <CEntryModal field={global?.entryModal} />
      <CReferencesModal field={global?.referencesModal} />
      {siteInfo.isKR && <CKrNewsletterModal />}
      <CTheFooter
        hasNewsletter={siteInfo.isUS}
        hasExtraBelow={['de-DE'].includes(siteInfo.iso ?? '')}
        hasExtraInline={['ko-KR'].includes(siteInfo.iso ?? '')}
        hasStaarLink={['ja-JP'].includes(siteInfo.iso ?? '')}
        fullDomain={''}
        discoveryUrl={siteInfo.discoverUrl}
        evoDocNumbers={global.evoDocNumber || []}
        topFooterLinks={global.topFooterLinks || []}
        bottomFooterLinks={global.bottomFooterLinks || []}
        bottomFooterCopyright={global.bottomFooterCopyright || []}
      />
      {siteInfo.isUS && <CExitIntentModal />}
      {isPreviewToastEnabled && <DynamicPreviewToast />}
    </main>
  )
}

export default DefaultLayout
